import React from "react";

interface IconProps {
  icon?: any;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const IconComponent: React.FC<IconProps> = ({
  icon: Icon,
  className,
  style,
  title,
}) => {
  if (!Icon) return null;

  return <Icon className={className} style={style} title={title} />;
};

export default IconComponent;
